// LoadingScreen.jsx
import React, { useEffect, useContext, useState } from "react";
import "./GameLoading.css";
import "../src/styles/font.css";
import { ScreenContext } from "./App";

// Loader

import loaderBG from "./Assets/Images/AppDashboard/GameLoading/LoaderBG.png";
import loader from "./Assets/Images/AppDashboard/GameLoading/loader.png";
import dice from "./Assets/Images/AppDashboard/GameLoading/loaderDice.png";

let handleZIndexChangeLoadingExport;

const GameLoading = () => {
  const [zIndex, setZIndex] = useState(1100); // Initial z-index value
  const [visible, setVisible] = useState(true); // Initial visibility state

  const handleScreenChange = useContext(ScreenContext);

  useEffect(() => {
    console.log(`Loading Screen Z Index Changed ====> ${zIndex}`);
  }, [zIndex]);

  useEffect(() => {
    console.log(`Initial Z Index of Loading Screen ====> ${zIndex}`);
  }, []); // Empty dependency array ensures the effect runs only once after mounting

  // You can adjust the zIndex value as needed
  //const zIndex = -1;

  function handleAnimationEnd() {
    //return;
    handleScreenChange("Splash");
  }

  const handleZIndexChange = (isAutoPlayDice) => {
    // console.log('Handle Z Index is Called || Player Selecion Screen');
    // Change the z-index value
    if (zIndex === 1100) {
      console.log("Setting Z Index to Negative");
      setZIndex(-1100);
      setVisible(false);
    }

    if (zIndex === -1100) {
      console.log("Setting Z Index to Positive");
      setZIndex(1100);
      setVisible(true);
    }

    //console.log(`Loading Screen ZIndex ====> ${zIndex}`);
  };

  handleZIndexChangeLoadingExport = handleZIndexChange;

  return (
    <div
      className="game-loading-screen"
      style={{ zIndex, visibility: visible ? "visible" : "hidden" }}
    >
      {/*style={{zIndex }} */}

      {/* Your Logo */}
      <img
        src={require("./Assets/Images/AppDashboard/SplashScreen/gameLogo.png")}
        alt="Logo"
        className="logo-image"
      />

      <img
        src={loaderBG}
        alt="loader"
        className="loader-bg-image"
        style={{
          position: "absolute",
          bottom: "3%",
          width: "35%",
          height:'4.2%',
          zIndex: 1,
        }}
      />

      <img
        src={loader}
        alt="loader-main"
        className="loader-main-image"
        style={{
          position: "absolute",
          bottom: "3.5%",
          width: "34.2%",
          height: "3%",
          left: "33%", 
          zIndex: 2, 
          clipPath: "inset(0% 100% 0% 0%)", 
          animation: "loadAnimation 5s forwards",
        }}
        onAnimationEnd={handleAnimationEnd}
      />

      <div
        style={{
          width: "10%",
          height: "auto",
          position: "absolute",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          left: "34%",
          bottom: "9%",
        }}
      >
        <img
          src={dice}
          alt="diceLogo"
          className="dice-image"
          style={{ width: "20%", height: "auto" }} // Adjust the size of the dice image as needed
        />
        <div
          style={{
            color: "white",
            fontSize: "1.5vw",
            fontFamily: "Gomarice",
            top: "30px",
          }}
        >
          Loading...
        </div>
      </div>
      {/* <div className="loader-bg-image">
        <img
          src={loaderBG}
          alt="loader"
          style={{
            width: "100%",
          }}
        />
      
      </div>
      <div className="loader-screen">
        <img
          src={loader}
          alt="loader-main"
          style={{width:'100%'}}
          
    
          onAnimationEnd={handleAnimationEnd}
        />

      </div> */}
    </div>
  );
};

export { handleZIndexChangeLoadingExport };
export default GameLoading;
